import { ChangeDetectionStrategy, Component, effect, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { AgentVisibilitySettingsDto, AgentVisibilityUpdateDto } from '@workspace/data-types';

@Component({
  selector: 'etxe-agent-visibility-form',
  imports: [MatIconModule, MatSlideToggleModule],
  templateUrl: './agent-visibility-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentVisibilityFormComponent {
  readonly settings = input<AgentVisibilitySettingsDto | undefined>(undefined);

  readonly settingsChange = output<AgentVisibilitySettingsDto>();
  readonly validityChanged = output<boolean>();
  readonly dtoChanged = output<{ dto: AgentVisibilityUpdateDto; changed: boolean }>();

  readonly internalSettings = signal<AgentVisibilitySettingsDto>({
    isPublic: true,
    isVacationMode: false,
    allowSearchIndexing: true,
  });

  constructor() {
    effect(() => {
      const s = this.settings() || {};
      const merged: AgentVisibilitySettingsDto = {
        isPublic: s.isPublic ?? true,
        isVacationMode: s.isVacationMode ?? false,
        allowSearchIndexing: s.allowSearchIndexing ?? true,
      };
      this.internalSettings.set(merged);
      this.validityChanged.emit(true);
      this.dtoChanged.emit({ dto: { visibility: merged }, changed: false });
    });
  }

  toggleField(field: keyof AgentVisibilitySettingsDto, checked: boolean): void {
    const updated: AgentVisibilitySettingsDto = {
      ...this.internalSettings(),
      [field]: checked,
    };
    this.internalSettings.set(updated);
    this.settingsChange.emit(updated);
    this.validityChanged.emit(true);
    this.dtoChanged.emit({
      dto: { visibility: updated },
      changed: true,
    });
  }
}
